import { render } from "./RecapSearch.component.vue?vue&type=template&id=6beb8c26"
import script from "./RecapSearch.component.vue?vue&type=script&lang=js"
export * from "./RecapSearch.component.vue?vue&type=script&lang=js"

import "./RecapSearch.component.vue?vue&type=style&index=0&id=6beb8c26&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__